// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1a50e64c","239":"afc70284","455":"8cfa050d"}[chunkId] + ".chunk.js";
};